var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between mb-0"},[(!_vm.isModal)?_c('Badge',{attrs:{"title":_vm.page.title,"i":_vm.page.icon}}):_c('BadgeModal',{attrs:{"title":_vm.page.title,"i":_vm.page.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }